<template>
  <!-- 这个是编辑项目的页面 -->
  <div class="contain">
    <!-- 这里边是标题和返回 -->
    <div class="title_box">
      <h4>查看外籍讲者邀请</h4></h4>
      <el-button size="small" type="info" @click="backProject">返回</el-button>
    </div>
    <!-- 这里边是一个card -->
    <el-card>
     <h4 class="title">结直肠癌病例分享与解析第一期会议</h4>
      <div class="meetingtype">会议平台:腾讯会议</div>
      <p class="meetingtimes">会议时间：2022-01-23 15:33:22-2022-01-23 15:33:22</p>
      <!-- 定位 -->
      <div class="position">
        <i class="iconfont icon-dizhi"></i>石家庄市长安区</div>
    </el-card>
    <el-card class="el-card big_box">
      <div class="box_kuang">
        <h4>会议日程</h4>
        <ul class="contents">
          <li><span>时间：2022-01-05 15:30——2022-02-03 15:30</span>          <span>议题：肿瘤常用的防治方法 </span>           <span>讲者：王俊凯</span></li>
          <li><span>时间：2022-01-05 15:30——2022-02-03 15:30</span>          <span>议题：肿瘤常用的防治方法 </span>           <span>讲者：王俊凯</span></li>
        </ul>
        <!-- 如果是直播，或者线上会议，线下会议，就把这里给隐藏掉 -->
        <h4>讲者姓名&机构</h4>
        <p class="jigou">中华医学会</p>
        <h4 class="changestyle">讲者姓名&机构</h4>
        <p class="jigou">肿瘤研究资料</p>
        <ul class="datas">
          <li>
            三阴型乳腺癌中AR、SOX10、EGFR和PD-L1的表达及临床意义
          </li>
        </ul>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'wjjzdetail',
  data () {
    return {

    }
  },
  methods: {
  }
}
</script>

<style lang='less' scoped>
.contain {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    h4 {
      font-size: 28px;
      color: #212529;
    }
  }
  .title {
    color: #212529;
    font-size: 16px;
    font-weight: bold;
  }
  .meetingtype {
    font-size: 12px;
    color: #9a9b9d;
    margin-top: 8px;
  }
  .meetingtimes {
    color: #212529;
    font-size: 13px;
    margin-top: 20px;
  }
  .position {
    color: #212529;
    font-size: 13px;
    margin-top: 60px;
    i {
      margin-right: 6px;
      vertical-align: middle;
    }
  }
  .big_box {
    margin-top: 40px;
    .box_kuang {
      border: 1px solid #f0f0f0;
      border-radius: 8px;
      padding: 25px;
      h4 {
        font-size: 16px;
        color: #212529;
      }
      .contents {
        margin-top: 25px;
        li {
          font-size: 13px;
          color: #212529;
          margin-bottom: 44px;
          span {
            margin-right: 40px;
          }
        }
      }
      .jigou {
        color: #212529;
        font-size: 13px;
        margin-top: 36px;
      }
      .changestyle {
        margin-top: 50px;
      }
      .datas {
        margin-top: 37px;
        color: #6167aa;
        font-size: 13px;
      }
    }
  }
}
</style>
